'use strict';
moduleConfig.registerModule('eclipseApp.liveChat', ['eclipseApp.core']);
